/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconRegistered = createReactComponent("outline", "registered", "IconRegistered", [["path", { "d": "M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0", "key": "svg-0" }], ["path", { "d": "M10 15v-6h2a2 2 0 1 1 0 4h-2", "key": "svg-1" }], ["path", { "d": "M14 15l-2 -2", "key": "svg-2" }]]);

export { IconRegistered as default };
//# sourceMappingURL=IconRegistered.mjs.map
